import { NavLink } from "@mantine/core";
import { links } from "./config";
import classes from "./Sidebar.module.css";
import useNavLinks from "./use-active-link";

const SidebarNavLinks = ({ onNavigate }: { onNavigate?: () => void }) => {
  const { active, handleLinkClick } = useNavLinks();

  const linksList = links.map((item) => (
    <NavLink
      className={classes.link}
      data-active={item.label === active ? true : undefined}
      href={item.link}
      label={item.label}
      key={item.label}
      onClick={(event) => {
        event.preventDefault();
        handleLinkClick(item.label, item.link);
        onNavigate?.();
      }}
      style={{ width: "80%" }}
      leftSection={item.icon && <item.icon size="1rem" stroke={1.5} />}
    />
  ));

  return (
    <div className={classes.navbarMain}>
      <div> {linksList}</div>
    </div>
  );
};

export default SidebarNavLinks;
